module.exports = __webpack_public_path__ + "static/SamAdams-Page_15-f51851a1fa2359ff5e9d75c03ce7e499.jpg";